import './Button.scss';

import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import ReactTooltip from 'react-tooltip';

const Button = ({ onClick, type, width, children, className, disabled, tooltip }) => {
	const onClickProp = {};
	if (typeof onClick === 'function' && !disabled) {
		onClickProp.onClick = onClick;
	}

	useEffect(() => {
		ReactTooltip.rebuild();
	}, [tooltip]);

	return (
		<button
			className={`react__login-btn react__login-btn-${type} ${className}`}
			data-disabled={disabled}
			data-tip={tooltip}
			style={{ width }}
			type='button'
			{...onClickProp}
		>
			<div className='label'>{children}</div>
			<i className='react__button-icon far fa-long-arrow-right' />
		</button>
	);
};

Button.propTypes = {
	type: PropTypes.oneOf(['primary', 'secondary', 'dark', 'slate', 'ghost']),
	width: PropTypes.string,
	className: PropTypes.string,
	tooltip: PropTypes.string,
	disabled: PropTypes.bool,
	children: PropTypes.node.isRequired,
	onClick: PropTypes.func
};

Button.defaultProps = {
	disabled: false,
	tooltip: null,
	className: null,
	type: 'primary',
	width: 'auto',
	onClick: false
};

export default Button;
